import { z } from 'zod'

export const schema = z.object({
  id: z.number(),
  attributes: z.object({
    publishedAt: z.string().nullable(),
    hero: z.object({
      author: z.string().min(1).nullable(),
      image: z.object({
        data: z.object({
          attributes: z.object({
            url: z.string().min(1),
          }),
        }),
      }),
    }),

    simple_banner: z
      .object({
        text: z.string().min(1),
        button: z
          .object({
            text: z.string().min(1),
            url: z.string().min(1).nullable(),
          })
          .nullable(),
      })
      .nullable(),

    intro_seo_text: z.object({
      title: z.string().min(1),
      text: z.string().min(1),
    }),

    image_banner: z
      .object({
        title: z.string().min(1),
        text: z.string().min(1),
        button: z
          .object({
            text: z.string().min(1),
            url: z.string().min(1).nullable(),
          })
          .nullable(),
        image: z.object({
          data: z.object({
            attributes: z.object({
              url: z.string().min(1),
            }),
          }),
        }),
      })
      .nullable(),

    featured_destinations: z.object({
      card_01: z.object({
        title: z.string().min(1),
        url: z.string().min(1),
        image: z.object({
          data: z.array(
            z.object({
              attributes: z.object({
                url: z.string().min(1),
              }),
            }),
          ),
        }),
      }),
      card_02: z.object({
        title: z.string().min(1),
        url: z.string().min(1),
        image: z.object({
          data: z.array(
            z.object({
              attributes: z.object({
                url: z.string().min(1),
              }),
            }),
          ),
        }),
      }),
      card_03: z.object({
        title: z.string().min(1),
        url: z.string().min(1),
        image: z.object({
          data: z.array(
            z.object({
              attributes: z.object({
                url: z.string().min(1),
              }),
            }),
          ),
        }),
      }),
      card_04: z.object({
        title: z.string().min(1),
        url: z.string().min(1),
        image: z.object({
          data: z.array(
            z.object({
              attributes: z.object({
                url: z.string().min(1),
              }),
            }),
          ),
        }),
      }),
    }),

    media_banner: z
      .object({
        title: z.string().min(1),
        subtitle: z.string().min(1),
        text: z.string().min(1),
        button: z.object({
          text: z.string().min(1),
          url: z.string().min(1).nullable(),
        }),
        youtube_url: z.string().min(1).nullable(),
        image: z.object({
          data: z
            .object({
              attributes: z.object({
                url: z.string().min(1),
              }),
            })
            .nullable(),
        }),
      })
      .nullable(),

    featured_searches: z.object({
      card_01: z.object({
        title: z.string().min(1),
        url: z.string().min(1),
        image: z.object({
          data: z.array(
            z.object({
              attributes: z.object({
                url: z.string().min(1),
              }),
            }),
          ),
        }),
      }),
      card_02: z.object({
        title: z.string().min(1),
        url: z.string().min(1),
        image: z.object({
          data: z.array(
            z.object({
              attributes: z.object({
                url: z.string().min(1),
              }),
            }),
          ),
        }),
      }),
      card_03: z.object({
        title: z.string().min(1),
        url: z.string().min(1),
        image: z.object({
          data: z.array(
            z.object({
              attributes: z.object({
                url: z.string().min(1),
              }),
            }),
          ),
        }),
      }),
      card_04: z.object({
        title: z.string().min(1),
        url: z.string().min(1),
        image: z.object({
          data: z.array(
            z.object({
              attributes: z.object({
                url: z.string().min(1),
              }),
            }),
          ),
        }),
      }),
      card_05: z.object({
        title: z.string().min(1),
        url: z.string().min(1),
        image: z.object({
          data: z.array(
            z.object({
              attributes: z.object({
                url: z.string().min(1),
              }),
            }),
          ),
        }),
      }),
    }),

    featured_cottages: z.array(
      z.object({
        title: z.string().min(1),
        filters: z.string(),
        button: z
          .object({
            text: z.string().min(1),
            url: z.string().min(1).nullable(),
          })
          .nullable(),
      }),
    ),

    featured_posts: z.object({
      title: z.string().min(1),
      slugs: z.string().min(1),
      button: z
        .object({
          text: z.string().min(1),
          url: z.string().min(1).nullable(),
        })
        .nullable(),
    }),
  }),
})

export type schemaType = z.infer<typeof schema>
